import { createAction } from "@reduxjs/toolkit";

export const signOut = createAction("SIGN_OUT");
